module.exports = __webpack_public_path__ + "img/front_10.29cc7bf0.svg";